import { useState, useEffect, useCallback } from 'react';
import { BankNavigation } from '../bancos/BankNavigation';

import moment from 'moment'
import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { es } from 'date-fns/locale'

// estilos
import '../../assets/style/componentPrincipal.css'
import '../../assets/style/tablesG.css'

// componentes
import { Buscar } from '../general/buscadorPagos/Buscar';
import { ModalProgress } from '../modals/ModalProgress';
import { TableList } from './TableList';

import { Model } from '../../models/model';
import { Breadcrumb } from '../reusableUI/Breadcrumb';

export const PagosList = () => {

    const [loading, setLoading] = useState(true)
    const [pagosList, setPagosList] = useState([])

    const [filters, setFilters] = useState({
        time: 'month',
        text: '',
        fecha_desde: new Date(),
        fecha_hasta: new Date(),
        check_emitida: true,
        check_pagada: true,
        page: 1,
        rows: 10
    })

    const handleGetAll = useCallback(async () => {
        const resultGet = await Model.getAll({
            url: `pagos/?${(new URLSearchParams(filters)).toString()}`
        })

        setPagosList(resultGet)
    }, [filters])

    const handleChangeDateDesde = (newValue) => {
        setFilters({
            ...filters,
            fecha_desde: newValue
        })
    }

    const handleChangeDateHasta = (newValue) => {
        setFilters({
            ...filters,
            fecha_hasta: newValue
        })
    }

    useEffect(() => {
        setLoading(true)
        handleGetAll(filters)
        setLoading(false)
    }, [filters, handleGetAll])

    return (
        <div className='p-container'>
            {loading && <ModalProgress />}

            {/* <h1 className='p-title'>Pagos a proveedores</h1> */}

            <div>
                <Breadcrumb
                    routes={[
                        { id: 1, name: 'Bancos', link: '/banks/tra', active: false },
                        { id: 2, name: 'Movimientos', link: '/banks/tra', active: false },
                        { id: 2, name: 'Pagos', link: '/banks/exp', active: true },
                    ]}
                />
            </div>

            <DateFilters
                filters={filters}
                setFilters={setFilters}
                handleChangeDateDesde={handleChangeDateDesde}
                handleChangeDateHasta={handleChangeDateHasta}
            />

            <div className='row p-box-searching'>
                <div className='col d-flex'>
                    <Buscar
                        filters={filters}
                        setFilters={setFilters}
                    />
                </div>
            </div>

            <BankNavigation />

            <TableList
                filters={filters}
                setFilters={setFilters}
                dataList={pagosList}
            />

        </div >
    )
}

const DateFilters = ({ filters, setFilters, handleChangeDateDesde, handleChangeDateHasta }) => {
    return (
        <>
            <div className="row mt-3">
                <div className="col text-start">
                    <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                        <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off"
                            checked={filters.time === 'year' && 'checked'}
                            onChange={() => setFilters({ ...filters, time: 'year' })}
                        />
                        <label className="btn btn-outline-light" htmlFor="btnradio1" style={{ color: filters.time === 'year' ? '#8E24AA' : '#595759' }}>
                            Anual ({moment(filters.fecha_desde).format('YYYY')})
                        </label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off"
                            checked={filters.time === 'month' && 'checked'}
                            onChange={() => setFilters({ ...filters, time: 'month' })}
                        />
                        <label className="btn btn-outline-light" htmlFor="btnradio2" style={{ color: filters.time === 'month' ? '#8E24AA' : '#595759' }}>
                            Mensual (<span style={{ textTransform: 'capitalize' }}>{moment(filters.fecha_desde).format('MMMM')}</span>{' '}{moment(filters.fecha_desde).format('YYYY')})
                        </label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio3" autoComplete="off"
                            checked={filters.time === 'range' && 'checked'}
                            onChange={() => setFilters({ ...filters, time: 'range' })}
                        />
                        <label className="btn btn-outline-light" htmlFor="btnradio3" style={{ color: filters.time === 'range' ? '#8E24AA' : '#595759' }}>
                            Rango
                        </label>
                    </div>
                </div>
            </div>

            {filters.time === 'year' &&
                <div className='mt-4 p-text-date-year'>
                    <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                        <DatePicker
                            views={['year']}
                            label="Año"
                            openTo="year"
                            name='fecha_desde'
                            minDate={new Date('2020-01-01')}
                            value={filters.fecha_desde}
                            onChange={handleChangeDateDesde}
                            renderInput={(params) => <TextField {...params} helperText={null} />}
                        />
                    </LocalizationProvider>
                </div>
            }

            {filters.time === 'month' &&
                <div className='mt-4 p-text-date-month'>
                    <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                        <DatePicker
                            views={['year', 'month']}
                            label="Mes"
                            openTo="month"
                            name='fecha_desde'
                            minDate={new Date('2020-01-01')}
                            value={filters.fecha_desde}
                            onChange={handleChangeDateDesde}
                            renderInput={(params) => <TextField {...params} helperText={null} />}
                        />
                    </LocalizationProvider>
                </div>
            }

            {filters.time === 'range' &&
                <div className="row mt-4">
                    <div className="col text-start d-flex justify-content-start p-text-date-range">
                        <span>
                            <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    views={['year', 'month']}
                                    label="Mes desde"
                                    openTo="month"
                                    name='fecha_desde'
                                    minDate={new Date('2020-01-01')}
                                    value={filters.fecha_desde}
                                    onChange={handleChangeDateDesde}
                                    renderInput={(params) => <TextField {...params} helperText={null} />}
                                />
                            </LocalizationProvider>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    views={['year', 'month']}
                                    label="Mes hasta"
                                    openTo="month"
                                    name='fecha_hasta'
                                    minDate={new Date('2020-01-01')}
                                    value={filters.fecha_hasta}
                                    onChange={handleChangeDateHasta}
                                    renderInput={(params) => <TextField {...params} helperText={null} />}
                                />
                            </LocalizationProvider>
                        </span>
                    </div>
                </div>
            }

        </>
    )

}
